<div id="{{modalId}}" tabindex="-1" class="dds__modal dds__fade  modal-backdrop" role="dialog" aria-hidden="true"> 
    <div class="dds__modal-dialog" role="document">
        <div class="dds__modal-content">
            <ng-content select="[modal-close]"></ng-content>
            <div class="dds__modal-body">
                <ng-content select="[modal-body]"></ng-content>
            </div> 
    </div>
</div>
<a #triggerContainer>
    <ng-content select="[modal-trigger]"></ng-content>
</a>